// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import HelpOutlineIcon from '@mui/icons-material/HelpOutlined';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { ACTIVE_BUTTON_BLUE } from 'constants/ColorConstants';
import { useIntercomArticle } from 'projects/hooks/useIntercomArticle';

const GLYPH_ICONS = {
  'question-sign': HelpOutlineIcon,
  'book': MenuBookIcon,
};

// Explicit testids: MUI only auto-adds data-testid in development builds,
// and the Cypress suite selects these icons against production packs.
const GLYPH_TEST_IDS = {
  'question-sign': 'HelpOutlinedIcon',
  'book': 'MenuBookIcon',
};

function HelpLink({ intercomArticle, glyph = 'question-sign', children }) {
  const handleClick = useIntercomArticle(intercomArticle);
  const GlyphIcon = GLYPH_ICONS[glyph] || HelpOutlineIcon;

  return (
    <div className="help-link" style={{ fontSize: '14px' }}>
      <GlyphIcon
        data-testid={GLYPH_TEST_IDS[glyph] || 'HelpOutlinedIcon'}
        style={{color: ACTIVE_BUTTON_BLUE, fontSize: '16px', verticalAlign: 'text-bottom'}}
      />
      {' '}<a href="#" onClick={handleClick}>
        {children}
      </a>
    </div>
  )
}

export default HelpLink;